import React from 'react';

const SPINNER_SIZES = { small: 24, medium: 32, large: 40, xlarge: 48, hundred: 40 };

const Loading = ({ size = 'large', message = 'Caricamento...' }) => {
  const s = SPINNER_SIZES[size] || 40;

  return (
    <div className="flex flex-col items-center justify-center py-8">
      <div
        style={{
          width: s, height: s, borderRadius: '50%',
          border: '3px solid var(--c-border, #e5e5e5)',
          borderTopColor: '#191919',
          animation: 'spin 0.7s linear infinite',
          marginBottom: 16,
        }}
      />
      {message && (
        <p className="text-stone-600 text-center" style={{ fontFamily: 'Manrope-Variable', fontSize: 13 }}>{message}</p>
      )}
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  );
};

export default Loading;